import { render, staticRenderFns } from "./PeopleHeader.vue?vue&type=template&id=4ec2bb5a&lang=pug"
import script from "./PeopleHeader.vue?vue&type=script&lang=js"
export * from "./PeopleHeader.vue?vue&type=script&lang=js"
import style0 from "./PeopleHeader.vue?vue&type=style&index=0&id=4ec2bb5a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports